import { render, staticRenderFns } from "./UpdateCoverages.vue?vue&type=template&id=11307228"
import script from "./UpdateCoverages.vue?vue&type=script&lang=js"
export * from "./UpdateCoverages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports